import { Entity } from '@betgames/bg-state-manager';
import { GameId } from '@bg-shared/enums/GameId';
import FavoriteOptionsApi from './FavoriteOptions.api';

export default class FavoriteOptionsEntity extends Entity<number[], GameId> {
    constructor(private readonly repository: FavoriteOptionsApi) {
        super({
            key: 'FavoriteOptions',
            default: [],
        });
    }

    public update(gameId: GameId, ids: number[]): void {
        super.store(gameId).update(ids);
    }

    public toggle(gameId: GameId, optionId: number): void {
        const toggle = !this.store(gameId).value.includes(optionId);
        const apiCall = toggle ? this.repository.save(optionId) : this.repository.remove(optionId);

        apiCall.then(() => {
            super.store(gameId).update((draft) => {
                const index = draft.indexOf(optionId);

                if (!toggle) {
                    draft.splice(index, 1);
                } else {
                    draft.push(optionId);
                }
            });
        });
    }
}
